import type { CommunicationTemplateType } from "@bbj-types/communication/enum";
import { Autocomplete, Box, Stack, TextField, Typography } from "@mui/material";
import { useMemo } from "react";
import { type Control, Controller, type UseFormSetValue } from "react-hook-form";
import type { IModalTemplate } from ".";
import type { INotifyByEmailModalForm } from "../types";

interface IWorkshopTemplateListFormProps {
  control: Control<INotifyByEmailModalForm, void>;
  setValue: UseFormSetValue<INotifyByEmailModalForm>;
  templates: (IModalTemplate & { type: CommunicationTemplateType.EMAIL })[];
}

export const MenuTemplate = ({ control, templates, setValue }: IWorkshopTemplateListFormProps) => {
  const parsedTemplates = useMemo(() => {
    const result = new Map<string, Omit<IModalTemplate, "_id">>();

    return templates.reduce((acc, curr) => {
      const { _id, ...rest } = curr;
      acc.set(_id, rest);
      return acc;
    }, result);
  }, [templates]);

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
      }}
    >
      <Typography
        variant="body1"
        sx={{
          minWidth: "7%",
          whiteSpace: "nowrap",
        }}
      >
        Modèle :
      </Typography>
      <Controller
        control={control}
        name="templateType"
        render={({ field: { onChange }, fieldState: { error } }) => (
          <Autocomplete
            options={templates}
            getOptionLabel={(template) => template.name}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            onChange={(_, value) => {
              onChange(value?.name);
              const content = parsedTemplates.get(value?._id ?? "")?.content ?? "";
              setValue("subject", parsedTemplates.get(value?._id ?? "")?.subject ?? "");
              setValue("content", {
                text: content,
                html: content,
              });
            }}
            size="small"
            sx={{ minWidth: "360px" }}
            renderInput={(props) => (
              <TextField {...props} error={!!error} helperText={error?.message} label={<Box>Modèle</Box>} />
            )}
          />
        )}
      />
    </Stack>
  );
};
